var map = {
	"./action.svg": 20,
	"./address-location.svg": 14,
	"./arrow-to-left.svg": 21,
	"./arrow-to-top.svg": 22,
	"./arrows-back.svg": 15,
	"./back.svg": 23,
	"./checked.svg": 24,
	"./checked2.svg": 25,
	"./circle-cross.svg": 16,
	"./close.svg": 26,
	"./cross.svg": 27,
	"./down.svg": 28,
	"./github.svg": 29,
	"./hook-red.svg": 17,
	"./message.svg": 30,
	"./minus.svg": 11,
	"./more.svg": 31,
	"./more2.svg": 32,
	"./more3.svg": 33,
	"./notice.svg": 34,
	"./plus.svg": 12,
	"./qrcode.svg": 35,
	"./right.svg": 36,
	"./search.svg": 37,
	"./search2.svg": 38,
	"./share.svg": 39,
	"./tick-red.svg": 18,
	"./tick.svg": 40,
	"./top.svg": 41,
	"./trolley.svg": 42,
	"./unchecked.svg": 43
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;